
import React, { useState } from 'react';
import {
    Card, CardBody, Row, Col, Form, FormGroup, Label, Input, Button, Table, Badge, Alert,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';


const Guardrails = ({ channelDetails, saveIntegration }) => {
    // Configurable rules state
    const [confidenceThreshold, setConfidenceThreshold] = useState(channelDetails?.guardrails?.confidence || 80);


    // Simulated email input and evaluation state (dynamic list)
    const [emailInputList, setEmailInputList] = useState(channelDetails?.guardrails?.emails || [
    ]);

    const addNewEmailInput = () => {
        setEmailInputList([
            ...emailInputList,
            { id: Date.now() + Math.random(), key: '', content: '' }
        ]);
    };
    const handleEmailInputChange = (idx, updated) => {
        setEmailInputList(emailInputList.map((item, i) => i === idx ? { ...item, ...updated } : item));
    };
    const removeEmailInput = (idx) => {
        setEmailInputList(emailInputList.filter((_, i) => i !== idx));
    };


    const updateEmailInputResult = (idx, detectedIntent, result) => {
        setEmailInputList(emailInputList.map((item, i) => i === idx ? { ...item, detectedIntent, result } : item));
    };

    // Forward rules (dynamic input list) - forward matching emails/domains to another address
    // Use objects { id, intent, email } — normalize older string entries
    const [forwardRules, setForwardRules] = useState((channelDetails?.guardrails?.forwardEmailRules || []).map(fr => {
        if (typeof fr === 'string') return { id: Date.now() + Math.random(), intent: '', email: fr };
        return {
            id: fr.id || Date.now() + Math.random(),
            intent: fr.intent || fr.key || '',
            email: fr.email || fr.value || ''
        };
    }));
    const addNewForwardRule = () => {
        setForwardRules([
            ...forwardRules,
            { id: Date.now() + Math.random(), intent: '', email: '' }
        ]);
    };
    const handleForwardRuleChange = (index, updated) => {
        setForwardRules(forwardRules.map((item, i) => i === index ? updated : item));
    };
    const removeForwardRule = (index) => {
        setForwardRules(forwardRules.filter((_, i) => i !== index));
    };

    // Include / Exclude mode: show inbound rules when 'Include' selected
    const [guardrailMode, setGuardrailMode] = useState(channelDetails?.guardrails?.guardrailMode || '');

    // Inbound variants (same behavior as original lists but for 'Include' mode)
    const [inboundEmailInputList, setInboundEmailInputList] = useState(channelDetails?.guardrails?.includeEmails || []);
    const addNewInboundEmailInput = () => {
        setInboundEmailInputList([
            ...inboundEmailInputList,
            { id: Date.now() + Math.random(), key: '', content: '' }
        ]);
    };
    const handleInboundEmailInputChange = (idx, updated) => {
        setInboundEmailInputList(inboundEmailInputList.map((item, i) => i === idx ? { ...item, ...updated } : item));
    };
    const removeInboundEmailInput = (idx) => {
        setInboundEmailInputList(inboundEmailInputList.filter((_, i) => i !== idx));
    };

    const [inboundSenderRuleList, setInboundSenderRuleList] = useState(channelDetails?.guardrails?.includeDomains || []);
    const addNewInboundSenderRuleInput = () => {
        setInboundSenderRuleList([
            ...inboundSenderRuleList,
            { id: Date.now() + Math.random(), key: '', value: 'NoResponse' }
        ]);
    };
    const handleNewInboundSenderRuleChange = (idx, updatedRule) => {
        setInboundSenderRuleList(inboundSenderRuleList.map((rule, i) => i === idx ? updatedRule : rule));
    };
    const removeNewInboundSenderRule = (idx) => {
        setInboundSenderRuleList(inboundSenderRuleList.filter((_, i) => i !== idx));
    };

    // Add/delete row handlers for key-Based Restrictions (dynamic input list)n
    const [newSenderRuleList, setNewSenderRuleList] = useState(channelDetails?.guardrails?.domains || [
    ]);
    const addNewSenderRuleInput = () => {
        setNewSenderRuleList([
            ...newSenderRuleList,
            { id: Date.now() + Math.random(), key: '', value: 'NoResponse' }
        ]);
    };
    const handleNewSenderRuleChange = (idx, updatedRule) => {
        setNewSenderRuleList(newSenderRuleList.map((rule, i) => i === idx ? updatedRule : rule));
    };
    const removeNewSenderRule = (idx) => {
        setNewSenderRuleList(newSenderRuleList.filter((_, i) => i !== idx));
    };


    // Add/delete row handlers for key Checks (dynamic input list)
    const [newIntentRuleList, setNewIntentRuleList] = useState(channelDetails?.guardrails?.contents || [
    ]);
    const addNewIntentRuleInput = () => {
        setNewIntentRuleList([
            ...newIntentRuleList,
            { id: Date.now() + Math.random(), key: '', value: 'NoResponse' }
        ]);
    };
    const handleNewIntentRuleChange = (idx, updatedRule) => {
        setNewIntentRuleList(newIntentRuleList.map((rule, i) => i === idx ? updatedRule : rule));
    };
    const removeNewIntentRule = (idx) => {
        setNewIntentRuleList(newIntentRuleList.filter((_, i) => i !== idx));
    };

    const handleSave = () => {
        let guardrails = {
            confidence: confidenceThreshold,
            emails: emailInputList,
            domains: newSenderRuleList,
            contents: newIntentRuleList,
            forwardEmailRules: forwardRules,
            guardrailMode,
            includeEmails: inboundEmailInputList,
            includeDomains: inboundSenderRuleList
        };
        channelDetails.guardrails = guardrails;
        saveIntegration({ channelDetails: channelDetails });
    }

    return (
        <Card>
            <CardBody>
                <div className="text-center mb-2">
                    <h6 className="mb-2">Email Response Guardrails</h6>
                </div>
                <Separator className="mb-3" />
                <Card className="p-4 m-4">
                    <Card className="py-3 px-2 mb-3">
                        <Col md={12} className="my-1">
                            <p className="mb-2"><strong>Email Filtering Mode</strong><br /></p>
                            <p className="">Control which emails are automated by allowing or blocking selected domains or senders.</p>
                        </Col>
                        <Col md={12} className="my-1">
                            <div className="form-check form-check-inline">
                                <Input type="radio" name="includeExclude" id="includeModeInclude" checked={guardrailMode == 'Include'} onChange={() => setGuardrailMode('Include')} />
                                <Label for="includeModeInclude" className="mb-0 ml-2">Include Mode (only process selected senders)</Label>
                            </div>
                        </Col>
                        <Col md={12} className="my-1">
                            <div className="form-check form-check-inline">
                                <Input type="radio" name="includeExclude" id="includeModeExclude" checked={guardrailMode == 'Exclude'} onChange={() => setGuardrailMode('Exclude')} />
                                <Label for="includeModeExclude" className="mb-0 ml-2">Exclude Mode (ignore selected senders)</Label>
                            </div>
                        </Col>

                    </Card>


                    {/* Conditionally render Exclude (original) or Include (inbound) lists */}
                    {guardrailMode == 'Exclude' && (
                        <Card className="py-3 px-2 mb-3">

                            <Col md={12} className="my-2">
                                <h6 className="mb-2">Exclude Mode</h6>
                                <p className="mb-2">All rules are evaluated in order: Sender Based Processing → Content & Intent Checks → Confidence Accuracy.</p>
                            </Col>

                            <Col md={12}>
                                <h6 className="mb-2">Sender Based Restrictions</h6>
                                <p className="mb-2">Do not respond to emails from specific domains</p>
                                {/* Dynamic list of new key rule inputs */}
                                {newSenderRuleList.map((rule, idx) => (
                                    <Row key={rule.id} className="mb-2 gx-2">
                                        <Col xs={6} className="">
                                            <Input key="text" placeholder="Domain" value={rule.key} onChange={e => handleNewSenderRuleChange(idx, { ...rule, key: e.target.value })} style={{ width: '100%' }} />
                                        </Col>
                                        <Col xs={4} className="px-0">
                                            <Input
                                                type="select"
                                                value={rule.value}
                                                onChange={e => handleNewSenderRuleChange(idx, { ...rule, value: e.target.value })}
                                                style={{ width: '100%' }}
                                            >
                                                <option value="NoResponse">No Response</option>
                                                <option value="AutoResponse">Auto Response</option>
                                                <option value="Draft">Generate Draft</option>
                                                <option value="Forward">Forward Email</option>
                                            </Input>
                                        </Col>
                                        <Col xs={2} className="d-flex align-items-center">
                                            <Button color="danger" outline size="xs" key="button" onClick={() => removeNewSenderRule(idx)}>X</Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button color="primary" outline size="xs" key="button" className="mb-3" onClick={addNewSenderRuleInput}>+ Add Domain</Button>
                            </Col>
                            <Col md={12}>
                                <p className="mb-2">Do not respond to emails from specific email addresses</p>
                                {emailInputList.map((item, idx) => (
                                    <Row key={item.id} className="mb-2 gx-2">
                                        <Col xs={6} className="">
                                            <Input
                                                id={`key-${item.id}`}
                                                key="email"
                                                placeholder="Email (e.g. user@domain.com)"
                                                required
                                                value={item.key}
                                                onChange={e => handleEmailInputChange(idx, { key: e.target.value })}
                                                style={{ width: '100%' }}
                                            />
                                        </Col>
                                        <Col xs={4} className="px-0">
                                            <Input
                                                type="select"
                                                value={item.value}
                                                onChange={e => handleEmailInputChange(idx, { ...item, value: e.target.value })}
                                                style={{ width: '100%' }}
                                            >
                                                <option value="NoResponse">No Response</option>
                                                <option value="AutoResponse">Auto Response</option>
                                                <option value="Draft">Generate Draft</option>
                                                <option value="Forward">Forward Email</option>
                                            </Input>
                                        </Col>
                                        <Col xs={2} className="d-flex align-items-center">
                                            <Button color="danger" outline size="xs" key="button" className="" onClick={() => removeEmailInput(idx)}>X</Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewEmailInput}>+ Add Email</Button>
                            </Col>
                        </Card>
                    )}
                    {guardrailMode == 'Include' && (
                        <Card className="py-3 px-2 mb-3">
                            <Col md={12} className="my-2">
                                <h6 className="mb-2">Include Mode</h6>
                                <p className="mb-2">All rules are evaluated in order: Sender Based Restrictions → Content & Intent Checks → Confidence Accuracy.</p>
                            </Col>
                            <Col md={12}>
                                <h6 className="mb-2">Include - Sender Based</h6>
                                <p className="mb-2">Only include emails from specific domains</p>
                                {inboundSenderRuleList.map((rule, idx) => (
                                    <Row key={rule.id} className="mb-2 gx-2">
                                        <Col xs={6} className="">
                                            <Input key="text" placeholder="Domain" value={rule.key} onChange={e => handleNewInboundSenderRuleChange(idx, { ...rule, key: e.target.value })} style={{ width: '100%' }} />
                                        </Col>
                                        <Col xs={4} className="px-0">
                                            <Input
                                                type="select"
                                                value={rule.value}
                                                onChange={e => handleNewInboundSenderRuleChange(idx, { ...rule, value: e.target.value })}
                                                style={{ width: '100%' }}
                                            >
                                                <option value="NoResponse">No Response</option>
                                                <option value="AutoResponse">Auto Response</option>
                                                <option value="Draft">Generate Draft</option>
                                                <option value="Forward">Forward Email</option>
                                            </Input>
                                        </Col>
                                        <Col xs={2} className="d-flex align-items-center">
                                            <Button color="danger" outline size="xs" key="button" onClick={() => removeNewInboundSenderRule(idx)}>X</Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button color="primary" outline size="xs" key="button" className="mb-3" onClick={addNewInboundSenderRuleInput}>+ Add Domain</Button>
                            </Col>
                            <Col md={12}>
                                <p className="mb-2">Include specific email addresses</p>
                                {inboundEmailInputList.map((item, idx) => (
                                    <Row key={item.id} className="mb-2 gx-2">
                                        <Col xs={6} className="">
                                            <Input
                                                id={`inbound-key-${item.id}`}
                                                key="email"
                                                placeholder="Email (e.g. user@domain.com)"
                                                required
                                                value={item.key}
                                                onChange={e => handleInboundEmailInputChange(idx, { key: e.target.value })}
                                                style={{ width: '100%' }}
                                            />
                                        </Col>
                                        <Col xs={4} className="px-0">
                                            <Input
                                                type="select"
                                                value={item.value}
                                                onChange={e => handleInboundEmailInputChange(idx, { ...item, value: e.target.value })}
                                                style={{ width: '100%' }}
                                            >
                                                <option value="NoResponse">No Response</option>
                                                <option value="AutoResponse">Auto Response</option>
                                                <option value="Draft">Generate Draft</option>
                                                <option value="Forward">Forward Email</option>
                                            </Input>
                                        </Col>
                                        <Col xs={2} className="d-flex align-items-center">
                                            <Button color="danger" outline size="xs" key="button" className="" onClick={() => removeInboundEmailInput(idx)}>X</Button>
                                        </Col>
                                    </Row>
                                ))}
                                <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewInboundEmailInput}>+ Add Email</Button>
                            </Col>
                        </Card>
                    )}
                    <Card className="py-3 px-2 mb-3">
                        <Col md={12}>
                            <h6 className="mb-2">Content & Intent Checks</h6>
                            <p className='mb-2'>Do not respond if email contains the following intents</p>
                            {/* Dynamic list of new key rule inputs */}
                            {newIntentRuleList.map((rule, idx) => (
                                <Row key={rule.id} className="mb-2 gx-2">
                                    <Col xs={6} className="">
                                        <Input key="text" placeholder="Intent (e.g. Legal)" value={rule.key} onChange={e => handleNewIntentRuleChange(idx, { ...rule, key: e.target.value })} style={{ width: '100%' }} />
                                    </Col>
                                    <Col xs={4} className="px-0">
                                        <Input
                                            type="select"
                                            value={rule.value}
                                            onChange={e => handleNewIntentRuleChange(idx, { ...rule, value: e.target.value })}
                                            style={{ width: '100%' }}
                                        >
                                            <option value="NoResponse">No Response</option>
                                            <option value="AutoResponse">Auto Response</option>
                                            <option value="Draft">Generate Draft</option>
                                            <option value="Forward">Forward Email</option>
                                        </Input>
                                    </Col>
                                    <Col xs={2} className="d-flex align-items-center">
                                        <Button color="danger" outline size="xs" key="button" onClick={() => removeNewIntentRule(idx)}>X</Button>
                                    </Col>
                                </Row>
                            ))}
                            <Button color="primary" outline size="xs" key="button" className="mb-3" onClick={addNewIntentRuleInput}>+ Add Intent</Button>
                        </Col>
                        <Col md={12}>
                            <h6 className="mb-2">Forward Rules</h6>
                            <p className="mb-2">Forward matching emails or domains to another address</p>
                            {forwardRules.map((rule, index) => (
                                <Row key={rule.id} className="mb-2 gx-2">
                                    <Col xs={5} className="mb-1 pr-0">
                                        <Input
                                            placeholder="Intent (e.g. Billing)"
                                            value={rule.intent}
                                            onChange={e => handleForwardRuleChange(index, { ...rule, intent: e.target.value })}
                                            style={{ width: '100%' }}
                                        />
                                    </Col>
                                    <Col xs={5} className="mb-1 pr-0">
                                        <Input
                                            placeholder="Email"
                                            value={rule.email}
                                            onChange={e => handleForwardRuleChange(index, { ...rule, email: e.target.value })}
                                            style={{ width: '100%' }}
                                        />
                                    </Col>
                                    <Col xs={2} className="mb-1 d-flex align-items-center">
                                        <Button color="danger" outline size="xs" key="button" onClick={() => removeForwardRule(index)}>X</Button>
                                    </Col>
                                </Row>
                            ))}
                            <Button color="primary" outline size="xs" key="button" className="mb-2" onClick={addNewForwardRule}>+ Add Forward Rule</Button>
                        </Col>
                    </Card>
                    <Card className="py-3 px-2 mb-3">
                        <Col md={12} className="mb-2">
                            <h6 className="mb-2">Confidence Accuracy</h6>
                            <p className="mb-2">If confidence score less then a certain %age DO NOT generate or send response</p>
                            <Input
                                key="number"
                                min={0}
                                max={100}
                                value={confidenceThreshold}
                                onChange={e => setConfidenceThreshold(Number(e.target.value))}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </Card>
                </Card>
                <Separator className="my-3" />
                <Colxx md="12" className="text-center my-2">
                    <Button
                        color="primary"
                        size="xs"
                        outline
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Colxx>
            </CardBody>
        </Card>
    );
};

export default Guardrails;
